import map3D from "./map3D";
import map3DPopup from "./map3DPopup";
import map2DPopup from "./map2DPopup";
import mapScatter from "./mapScatter";
import heatmapChart from "./HeatmapChart";
import heatmapChart2 from "./HeatmapChart2";
import mapHeatmapChart from "./mapHeatmapChart";

import GpParser from "../../gpParser";
import { CATEGORIES } from "../../configuration/constants";

export default (editor, options) => {
  GpParser.loadFromList(
    [
      mapScatter,
      heatmapChart,
      heatmapChart2,
      map3D,
      map3DPopup,
      map2DPopup,
      mapHeatmapChart
    ],
    CATEGORIES.MAPS,
    editor,
    options
  );
};
